export default __webpack_public_path__ + "static/media/gen_close.a8fc895b.svg";